"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var setInboxRuleDiagnosticRequestStatus_1 = require("./helpers/setInboxRuleDiagnosticRequestStatus");
var getOutlookMigrationDiagnosticsService_1 = require("../services/getOutlookMigrationDiagnosticsService");
var owa_analytics_1 = require("owa-analytics");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Generates an inbox rule diagnostic report
 */
exports.default = legacy_1.action('generateInboxRulesDiagnosticReport', datapoints_1.default.generateInboxRulesDiagnosticReportDatapoint)(function removeInboxRule(state) {
    setInboxRuleDiagnosticRequestStatus_1.default(1 /* Pending */);
    var dataPoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    // TODO: Task 20143: Full error handling / success notification support
    return getOutlookMigrationDiagnosticsService_1.default()
        .then(function (response) {
        if (response) {
            setInboxRuleDiagnosticRequestStatus_1.default(2 /* Complete */);
        }
        else {
            dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error('GetOutlookMigrationDiagnostics service request failed'));
            setInboxRuleDiagnosticRequestStatus_1.default(3 /* Error */);
        }
    })
        .catch(function (error) {
        dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
        setInboxRuleDiagnosticRequestStatus_1.default(3 /* Error */);
    });
});
//# sourceMappingURL=generateInboxRulesDiagnosticReport.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/generateInboxRulesDiagnosticReport.js
// module id = 5216
// module chunks = 2